module.exports = "<div class=\"overlay2\">\n  <div class=\"overlay2__message\">{{message|e}}</div>\n  <div class=\"app-loader\"></div>\n</div>";
